export const TERMINAL_PAYMENT_IS_PROCESSING = 'TERMINAL_PAYMENT_IS_PROCESSING';
export const SET_TERMINAL_PAYMENT_RESULT = 'SET_TERMINAL_PAYMENT_RESULT';
export const SET_IS_PAYMENT_NOT_ALLOWED = 'SET_IS_PAYMENT_NOT_ALLOWED';
export const SET_PAYMENT_ERROR_CONDITION = 'SET_PAYMENT_ERROR_CONDITION';
export const SET_SHOULD_RETRY = 'SET_SHOULD_RETRY';
export const SET_IS_WENT_WRONG = 'SET_IS_WENT_WRONG';
export const RESET_PAYMENT_ERRORS = 'RESET_PAYMENT_ERRORS';
